<template>
  <div class="fts-drawer-main" @click="close">
    <div class="fts-drawer-container" :style="{width: getWidth}" :class="[getPosition ? getPosition : '']" @click.stop>
      <div class="fts-drawer-header">
        <slot name="drawerHeader" v-if="!!$slots.drawerHeader"></slot>
        <div class="default-header" v-else>
          <div class="header-title">{{title}}</div>
          <font-awesome-icon class="close-action" :icon="['fas', 'times']" fixed-width @click="close"/>
          <hr>
        </div> 
      </div>

      <slot name="drawerUpperContent" v-if="!!$slots.drawerUpperContent"></slot>

      <div class="fts-drawer-content">
        <slot name="drawerContent" v-if="!!$slots.drawerContent"></slot>
        <div v-else>Inistate</div>
        <!-- <div style="display: flex;flex-direction: column;flex: 1;">
          <div>.form-designer-header</div>
          <div style="display: flex;height: 100%;">
            <div style="width: 150px;height: 100%;overflow: auto;">
              .form-design-tool
            </div>

            <div style="flex: 1;height: 100%;overflow: auto;margin-left: 1rem;">
              .form-designer-element
            </div>
          </div>
        </div> -->
          
      </div>

      <slot name="drawerLowerContent" v-if="!!$slots.drawerLowerContent"></slot>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  props: {
    title: {
      type: String,
      default: () => {
        return 'Inistate';
      }
    },
    width: {
      type: String,
      default: () => {
        return '350px'
      }
    },
    fullWidth: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    position: {
      type: String
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
  computed: {
    getPosition() {
      if (this.position) {
        switch(this.position.toLowerCase()) {
          case 'left':
            return 'position-left'
          case 'right':
            return 'position-right'
          default:
            return false;
        }
      }
      return false
    },
    getWidth() {
      if(this.fullWidth) 
        return '100%';
      else  
        return this.width;
    }
  }
}
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/colors" as *;

.fts-drawer-main {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 300;
  background: rgba(0, 0, 0, 0.2);
  .fts-drawer-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;
    box-shadow: 0 12px 24px -6px rgba(9,30,66,.25), 0 0 0 1px rgba(9,30,66,.08);
    &.position-left {
      position: absolute;
    }
    &.position-right {
      position: absolute;   
      right: 0; 
    }
    .fts-drawer-header {     
      .default-header {
        display: flex;
        flex-direction: column;
        position: relative;
        padding: 0 1rem;
        .header-title { 
          flex: 1;
          margin: 1rem 2rem;
          text-align: center;
          text-transform: uppercase;
          font-size: 1.2rem;
          font-weight: bold;
        }
        .close-action {
          position: absolute;
          top: 50%;
          right: 1.2rem;
          transform: translate(0, -50%);
          -webkit-transform: translate(0, -50%);
          &:hover {
            cursor: pointer;
          }
        }
        > hr {
          margin: 0;
          width: 100%;
          height: 1px;
          border: 0;  
          background-color: $grayLightenColor;
        }
      }
    }
    .fts-drawer-content {
      display: flex;
      flex: 1 1 auto;
      padding: 1rem;
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
}
</style>